import { LoginComponent } from './login.component';
import { Routes } from '@angular/router';
var routes = [{ path: "", component: LoginComponent }];
var ɵ0 = LoginComponent;
var LoginModule = /** @class */ (function () {
    function LoginModule() {
    }
    return LoginModule;
}());
export { LoginModule };
export { ɵ0 };
